import { injectable } from 'inversify';
import { IResolvedTenor } from '../../interfaces';
import { ITenorResolveService } from './tenor-resolve.interface';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class TenorResolveMock implements ITenorResolveService {
    resolvedTenorObservable(): Observable<Array<IResolvedTenor>> {
        return NEVER;
    }
}
